<template>
    <div>Таблицы настройки планирования</div>
</template>

<script>
export default  {
    name: 'tables-planning-settings-view'
}
</script>